import { defaultTo } from 'ramda';
import { IRecommendedServicePackageServiceV2 } from '../../../../repositories/billing-tariffs/entities/PublishTerms/RecommendedServicePackageServiceV2';
import { IRecommendedPackageService } from '../../../../types/reducers/recommendedPackages';
import { mapServiceType } from './mapServiceType';
import { getServiceName } from './getServiceName';

export const mapPackageService = (service: IRecommendedServicePackageServiceV2): IRecommendedPackageService => {
  const { count, price, auctionPoints, durationInDays } = service;

  const serviceType = mapServiceType(service.serviceType);
  const name = getServiceName(serviceType);

  return {
    serviceType,
    name,
    count: defaultTo(0, count),
    price: defaultTo(0, price),
    auctionPoints: defaultTo(0, auctionPoints),
    durationInDays,
  };
};
